<template>
  <div class="project-rating-history">
    <ccd-header
      :numberType="$i18n.t('company.companyNumber')"
      :number="companyId"
      :description="description"
      :goToPrevious="true"
    />

    <div class="project-rating-body">
      <div class="clearfix header-panel">
        <div class="header">
          <div class="notice-header">
            <span class="title">{{ $i18n.t('performance.ratehistory') }}</span>
            <span class="btns">
              <button
                type="button"
                class="btn btn--darkblue"
                @click="resetFilter"
              >{{ $t('action.resetFilter') }}</button>
              <button
                type="button"
                class="btn btn--orange"
                @click="searchAndFilterProject"
              >{{ $t('company.performance.apply') }}</button>
            </span>
          </div>
          <div class="header-content">
            <div class="indicate">
              <span class="designPlanningDocumentation indicateItem"><span>{{ $t('project.rate.designPlanningDocumentation') }}</span></span>
              <span class="siteManagementCooperation indicateItem"><span>{{ $t('project.rate.siteManagementCooperation') }}</span></span>
              <span class="workQuality indicateItem"><span>{{ $t('project.rate.workQuality') }}</span></span>
              <span class="timelyServiceFollowUp indicateItem"><span>{{ $t('project.rate.timelyServiceFollowUp') }}</span></span>
              <span class="safetyTidinessCleanliness indicateItem"><span>{{ $t('project.rate.safetyEnvrionmental') }}</span></span>
            </div>
            <div class="filter-area">
              <search-filter
                v-for="item in advanceRatingList"
                :key="item.name"
                :label="item.title"
                :inputType="item.inputType"
                :type="item.name"
                :secondtype="item.style"
                :options="getOptions(item)"
                :multiple="item.multiple"
                :onchange="changeSearchConditoins"
                :value="getValue(item)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="rating-history-table">
        <table>
          <thead>
            <tr>
              <th
                v-for="item in ratingHistoryTable"
                :key="item.name"
                :class="item.name"
              ><span>{{ item.title }}</span></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(rate, index) in rates"
              :key="index"
            >
              <td
                v-for="item in ratingHistoryTable"
                :key="item.name"
                :class="item.name"
              >
                <span v-html="formatValue(rate[item.name], item)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import CcdHeader from '@/modules/ccd/CcdHeader'
import dateUtil from '@/utils/dateUtil'
import mutationTypes from '@/store/mutation-types'
import userHelper from '@/utils/userHelper'
import { expandTradeCategories, getPerformanceData, normalizeTradeCategorySelections, setupOptions } from '@/api/performance/request'
import { getPurchase, getPurchaseNumber } from '@/api/projects/util'
import { projectStatus } from '@/utils/locale'
import SearchFilter from '../../contacts/SearchFilter'
import {advanceRatingList, scoresMap, rateTypes, ratingHistoryTable} from './Contains'

export default {
  name: 'ProjectRatingHistory',
  components: {
    SearchFilter,
    CcdHeader,
  },
  props: {
    paramFilter: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      advanceRatingList: advanceRatingList,
      ratingHistoryTable: ratingHistoryTable,
      rateTypes: rateTypes,
      tenders: [],
      rates: [],
      srcImgs: {
        'Sadness': 'sad',
        'Expressionless': 'expressionless',
        'Smile': 'smile',
        'Laugh': 'laugh',
      },
      siteOptions: [],
      tradeOptions: [],
      searchConditions: {
        dateRange: { value: [null, null] },
        site: { value: [] },
        trade: { value: [] },
      },
      companyId: '',
      description: '',
      tradeCategoryMap: {},
    }
  },
  computed: {
    ...mapGetters('ccd', ['performanceSearchConditions']),
  },
  methods: {
    ...mapMutations('ccd', {
      setSearchConditions: mutationTypes.PERFORMANCE_SEARCH_CONDITIONS,
    }),
    goBack () {
      this.$router.goBack()
    },
    getValue (item) {
      return this.searchConditions[item.name].value
    },
    endOfDay (date) {
      if (date) {
        const seconds = (new Date(date)).getTime() + dateUtil.ONE_DAY_MILLI - 1
        return new Date(seconds)
      }
      return date
    },
    async doSearch () {
      const query = {
        startDay: this.searchConditions.dateRange.value[0],
        endDay: this.endOfDay(this.searchConditions.dateRange.value[1]),
        projectOnly: true,
        companyId: this.companyId,
      }

      if (!lodash.isEmpty(this.searchConditions.trade.value)) {
        query.category = this.getExpandedTradeCategories().join(',')
      }
      if (!lodash.isEmpty(this.searchConditions.site.value)) {
        query.site = lodash.get(this.searchConditions, 'site.value', []).join(',')
      }

      const performanceData = await getPerformanceData(query)
      return (performanceData[this.companyId] && performanceData[this.companyId].projects) || []
    },

    formatProjects (projects) {
      let showRates = []
      projects.map(project => {
        const purchase = getPurchase(project)
        let number = getPurchaseNumber(project.numberType, purchase)
        const rates = project.rates.map(rate => {
          rate.number = number
          rate.name = lodash.get(purchase, 'description')
          rate.site = lodash.get(purchase, 'siteId')
          rate.totalCost = purchase.amount
          rate.evaluator = userHelper.getUserName(lodash.get(project, 'manager.username'), lodash.get(project, 'manager.displayName'))
          const sum = lodash.sum(rateTypes.map(type => scoresMap[rate[type]]))
          rate.average = ((sum / rateTypes.length) / 4 * 100).toFixed(1)
          return rate
        })
        showRates = showRates.concat(rates)
      })
      return showRates
    },
    changeSearchConditoins (val) {
      const searchConditions = Object.assign({}, this.searchConditions, val)
      Object.entries(searchConditions).forEach(([key, value]) => {
        Vue.set(this.searchConditions, key, value)
      })
    },
    normalizeTradeSearchValue () {
      this.searchConditions.trade.value = normalizeTradeCategorySelections(
        lodash.get(this.searchConditions, 'trade.value', []),
        this.tradeOptions || [],
      )
    },
    getExpandedTradeCategories () {
      return expandTradeCategories(
        lodash.get(this.searchConditions, 'trade.value', []),
        this.tradeCategoryMap,
      )
    },
    /* eslint-disable */
    filtersList(ratesList) {
      return ratesList.filter(rate => {
        let flag = true
        switch (this.filter) {
          case 'comments':
            flag = !!rate.remark
            break
          case 'sad':
          case 'expressionless':
          case 'smile':
          case 'laugh':
            flag = this.existEmoj(rate)
            break
          default:
            break
        }
        return flag
      })
    },
    /* eslint-able */
    existEmoj(rate) {
      let flag = false
      for (let i = 0, len = rateTypes.length ; i < len; i++) {
        if (this.srcImgs[rate[rateTypes[i]]] === this.filter ) {
          flag = true
          break
        }
      }
      return flag
    },
    async searchAndFilterProject() {
      let list = await this.doSearch()
      list = list.filter(item => {
        return !(item.status === projectStatus.CANCELLED || item.status === projectStatus.DRAFT)
      })
      const ratesList = this.formatProjects(list)
      this.rates = this.filtersList(ratesList)
    },
    getOptions(item) {
      let ret = []
      switch (item.name) {
        case 'site':
          ret = this.siteOptions
          break
        case 'trade':
          ret = this.tradeOptions
          break
        default:
          break
      }
      return ret
    },
    resetFilter() {
      this.searchConditions = {
        dateRange: { value: [null, null] },
        site: { value: [] },
        trade: { value: [] }
      }
    },
    formatDate(time) {
      return dateUtil.formatDate(time)
    },
    formatValue(val, item) {
      let ret = val
      switch(item.name) {
        case 'designPlanningDocumentation':
        case 'siteManagementCooperation':
        case 'workQuality':
        case 'safetyTidinessCleanliness':
        case 'timelyServiceFollowUp':
          ret = `<img src=/${this.srcImgs[val]}-face.svg class=${this.srcImgs[val]} />`
          break
        case 'createdAt':
          ret = this.formatDate(val)
          break
        case 'evaluator':
          ret = val
      }
      return ret
    },
    initSearchConditions () {
      const nowTime = new Date()
      const oneYearAgo = new Date(moment(nowTime).add(-1, 'years').valueOf())
      const searchCondition = lodash.cloneDeep(this.performanceSearchConditions)
      this.searchConditions.dateRange = lodash.get(searchCondition, 'dateRange', this.searchConditions.dateRange)
      this.searchConditions.site = lodash.get(searchCondition, 'site', this.searchConditions.site)
      this.searchConditions.trade = lodash.get(searchCondition, 'trade', this.searchConditions.trade)
    }
  },
  async mounted () {
    const {startDay, endDay, site, companyId, description, trade, filter} = this.$router.currentRoute.params
    this.description = description
    this.companyId = companyId
    this.filter = filter
    const options = await setupOptions(this.companyId)
    this.siteOptions = options.sites
    this.tradeOptions = options.categories
    this.tradeCategoryMap = options.categoryMap || {}
    this.initSearchConditions()
    this.normalizeTradeSearchValue()
    await this.searchAndFilterProject()
  },
  beforeDestroy () {
    this.setSearchConditions({searchConditions: {
      dateRange: this.searchConditions.dateRange,
      site: this.searchConditions.site,
      trade: this.searchConditions.trade
    }})
  },
}
</script>
<style scoped src="styles/dashboard/style.scss"></style>
<style scoped src="styles/dashboard/datatable.scss"></style>
<style lang="scss">
.project-rating-history {
  .one {
    background: url('../../../../static/numberPng/1.svg') center
  }
  .two {
    background: url('../../../../static/numberPng/2.svg') center
  }
  .three {
    background: url('../../../../static/numberPng/3.svg') center
  }
  .four {
    background: url('../../../../static/numberPng/4.svg') center
  }
  .five {
    background: url('../../../../static/numberPng/5.svg') center
  }
  .project-rating-body {
    max-width: 1440px;
    margin: 0 auto;
  }
  .header-panel {
    padding: 15px 24px 0 24px;
    background: white;
    .header {
      display: inline-block;
      width: 100%;
      .notice-header {
        font-family: Georgia;
        font-weight: bold;
        font-size: 22px;
        height: 50px;
        line-height: 50px;
        .btns {
          position: relative;
          top: -5px;
          float: right;
          button {
            margin-left: 15px;
          }
        }
      }
      .header-content {
        width: 100%;
        display: flex;
        .indicate {
          font-size: 12px;
          flex: 1;
          padding-top: 10px;
          min-width: 400px;
          max-width: 530px;
          .before {
            background-size: cover !important;
            width: 15px;
            height: 15px;
            content: '';
            position: relative;
            top: 3px;
            display: inline-block;
          }
          .designPlanningDocumentation::before{
            @extend .before;
            @extend .one;
          }
          .siteManagementCooperation::before{
            @extend .before;
            @extend .two;
          }
          .workQuality::before{
            @extend .before;
            @extend .three;
          }
          .safetyTidinessCleanliness::before{
            @extend .before;
            @extend .five;
          }
          .timelyServiceFollowUp::before{
            @extend .before;
            @extend .four;
          }
          span {
            display: inline-block;
            margin-left: 5px;
          }
          .indicateItem {
            height: 30px;
            line-height: 30px;
          }
        }
        .filter-area {
          flex: 1;
          text-align: right;
          min-width: 500px;
          .search-filter-input {
            height: 70px;
            margin-left: 15px;
            text-align: left;
          }

        }
      }
    }
    .right-btns {
      float: right;
      .btn {
        margin-left: 16px;
      }
    }
  }

  .rating-history-table {
    padding: 20px;
  }
  .createdAt {
    width: 110px;
  }
  .numberPng {
    position: relative;
    top: 2px;
    width: 25px;
    height: 25px;
    display: inline-block;
    background-size: contain !important;
  }

  th.designPlanningDocumentation span{
    @extend .numberPng;
    @extend .one;
  }
  th.siteManagementCooperation span{
    @extend .numberPng;
    @extend .two;
  }
  th.workQuality span{
    @extend .numberPng;
    @extend .three;
  }
  th.safetyTidinessCleanliness span{
    @extend .numberPng;
    @extend .five;
  }
  th.timelyServiceFollowUp span{
    @extend .numberPng;
    @extend .four;
  }

  th.designPlanningDocumentation,
  th.siteManagementCooperation,
  th.workQuality,
  th.safetyTidinessCleanliness,
  th.timelyServiceFollowUp {
    width: 30px;
    min-width: 30px;
    max-width: 30px;
    padding: 10px 0;
    text-align: center;
  }

  td.designPlanningDocumentation,
  td.siteManagementCooperation,
  td.workQuality,
  td.safetyTidinessCleanliness,
  td.timelyServiceFollowUp {
    text-align: center;
    padding: 0;
    width: 30px;
    min-width: 30px;
    max-width: 30px;
    span {
      position: relative;
    }
    img {
      width: 25px;
      height: 25px;
      background: #ffcc00;
      border-radius: 50%;
    }
    img.sad {
      background: #ff1a1a;
    }
  }
  .evaluator {
    width: 150px;
  }
  tr th {
    cursor: default;
    padding: 10px;
  }

  .filter-result {
    height: calc(100vh - 377px);
    overflow: auto;
    margin: 0;
  }
}
</style>
